import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class TabNav extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            tabs: ['.m-tabNav__tab'],
        };
    }

    getPropsFromDom() {
        const props = {
            active: true,
            tabs: [],
        };

        for (let i = 0; i < this.dom.tabs.length; i += 1) {
            props.tabs.push({
                active: this.dom.tabs[i].querySelector('.m-tabNav__label')
                    .classList.contains('m-tabNav__label--active'),
                event: this.dom.tabs[i].querySelector('.m-tabNav__label').getAttribute('data-ga-event'),
                label: this.dom.tabs[i].querySelector('.m-tabNav__labelText').innerText,
                [this.dom.tabs[i].getAttribute('data-id')]: this.dom.tabs[i].querySelector('.m-tabNav__label')
                    .classList.contains('m-tabNav__label--active'),
                id: this.dom.tabs[i].getAttribute('data-id'),
                hasBranding: !!this.dom.tabs[i].querySelector('.m-tabNav__pill'),
                isBrandingSolution: !!this.dom.tabs[i].querySelector('.m-tabNav__pill--brandingSolution'),
            });
        }

        return props;
    }

    domEvents() {
        for (let i = 0; i < this.dom.tabs.length; i += 1) {
            this.dom.tabs[i].addEventListener('click', () => {
                this.toggleTab(i);
            });
        }
    }

    toggleTab(tabIndex) {
        if (this.props.tabs[tabIndex].active === false) {
            const newProps = this.props;
            for (let i = 0; i < newProps.tabs.length; i += 1) {
                newProps.tabs[i].active = false;
                newProps.tabs[i][newProps.tabs[i].id] = false;
            }
            newProps.tabs[tabIndex].active = true;
            newProps.tabs[tabIndex][newProps.tabs[tabIndex].id] = true;

            this.events.emit('changeTab', { newProps });
            this.updateProps(newProps);
        }
    }

    getActiveTab() {
        for (let i = 0; i < this.props.tabs.length; i += 1) {
            if (this.props.tabs[i].active) {
                return i;
            }
        }
        return false;
    }
}
